<div
  class="overflow-hidden text-base"
  [ngClass]="{ 'line-clamp-[4]': !expanded() && lines() === 4, 'line-clamp-[8]': !expanded() && lines() === 8 }"
>
  <ng-content />
</div>
<button
  type="button"
  class="mt-2 text-sm font-semibold underline"
  (click)="toggle($event)"
>
  {{ expanded() ? 'Weniger anzeigen' : 'Mehr anzeigen' }}
</button>
